<!--
 * @Author: chengjia 645680217@qq.com
 * @Date: 2022-10-26 10:50:57
 * @LastEditors: chengjia 645680217@qq.com
 * @LastEditTime: 2022-11-04 16:54:36
 * @FilePath: \xm-runing-extend\src\views\msgMain\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
    <div class="msgRight">
        <!-- 消息为流程消息 -->
        <div v-if="(msgDetail as any).inBoxType === 'flow'" class="msgRight__flowMsg">
            <flow-msg-item />
        </div>

    </div>
</template>
    
<script lang="ts" >
import { defineComponent} from 'vue';
import { storeToRefs } from 'pinia';
export default defineComponent({
    components: {},
    name: "msgRight",
});
</script>
    
<script lang="ts" setup>
import flowMsgItem from './flowMsgItem.vue'
import { msgStore } from '@/store/modules/msgStore'
const store = msgStore()
const {msgDetail} = storeToRefs(store)

</script>
    
<style type="text/css" lang="less" scoped>
.msgRight {
    padding: 15px 0px 0px 15px;
    width: 100%;
    height: 85vh;
    overflow: auto;
    display: flex;

    &__flowMsg {
        width: 100%;
        background-color: #f1f2f3;
        border-radius: 6px;
        border: 1px solid #f1f2f3;
        padding: 30px 30px;

    }
}
</style>
